import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import { ElMessage } from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App);
app.use(store)
app.use(ElementPlus)
app.use(router)
app.config.globalProperties.$ElMessage = ElMessage
app.mount('#app')
